import React from "react";
import "./ServiceCard.scss"
import Button from "../Button/Button";
import { useHistory } from "react-router";
import { useDispatch } from "react-redux";
import { setIsComing } from "../../../../../../../redux/companyDataSlice";
const ServiceCard = ({ service }) => {
    const history = useHistory()
    const dispatch = useDispatch()

    return (
        <div className="VirasatDefault-ServiceCard"
            style={{
                backgroundImage: ` linear-gradient(0deg, rgba(0, 0, 0, 0.67) 45.67%, rgba(102, 102, 102, 0) 100%),
url(${service?.src})`
            }}>
            <div className="VirasatDefault-ServiceCard-icon">
                <div className="VirasatDefault-ServiceCard-icon-inner">
                    <img alt="" src={service?.icon} />
                </div>
            </div>
            <div className="VirasatDefault-ServiceCard-inner">
                <div className="VirasatDefault-ServiceCard-inner-cont">
                    <div className="VirasatDefault-ServiceCard-inner-cont-text">
                        {service?.text}
                    </div>
                    <div className="VirasatDefault-ServiceCard-inner-cont-btn">

                        <Button text={service?.buttonText}
                            onClick={() => {
                                if (service?.href?.includes("https://")) {
                                    if (service?.href && service?.href !== "") {
                                        window.open(service?.href, '_blank')
                                    }
                                    else {
                                        dispatch(setIsComing(true))
                                    }
                                } else {
                                    history.push(service?.href)
                                }
                            }} />
                    </div>
                </div>
            </div>
        </div>
    )
}
export default ServiceCard